/**
 * html处理器
 * @param {string} content 原文
 * @param {string} word 敏感词
 * @param {string} replaceHtml 要替换为的词
 * */
export const checkWordReplace = function (content, word, replaceHtml) {
    let newTxt = content;
    // let regex = '(?<=^|>)[^><]+?(?=($|<))';
    // let regex = '(?<=(^|>))[^><]+?(?=($|<))';
    // let regex = /(?<=(^|>))[^><]+?(?=($|<))/g;
    /**
     * 由于safari浏览器兼容性问题，这里尝试了很多正则
     * */
    const regex = /(^|>)[^><]+?(?=$|<)/g;
    return  newTxt.replace(regex, (match) => {
        return match.replace(new RegExp(word,"g"), replaceHtml);
    });
}
